<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/inventory/supplier" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditSupplier") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <vx-card class="form-padding">
        <div class="vx-row">
          <div class="vx-col w-full"></div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.SupplierCode')"
            >
              <vs-input
                :label="$t('setup.label.SupplierCode')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="supplier.supplierCode"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.SupplierDescription')"
            >
              <vs-input
                :label="$t('setup.label.SupplierDescription')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="supplier.supplierDescription"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>

          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div style="height: 20px"></div>
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.SupplierAddress")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="$t('setup.label.SupplierAddress')"
              >
                <vs-textarea
                  :placeholder="$t('setup.label.EnterSupplierAddress')"
                  v-model="supplier.supplierAddress"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </vx-card>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="validateForm"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const supplierEmptyObj = {
  supplierCode: "",
  supplierAddress: "",
  supplierDescription: "",
};

export default {
  data() {
    return {
      supplier: supplierEmptyObj,
      warningPopup: false,
      warningText: "",
      errors: [],
      errorMessage: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      supplierObj: (state) => state.supplier.supplierById,
      postResponse: (state) => state.supplier.updateSupplier,
      errorMessage: (state) => state.supplier.formError,
    }),
  },
  methods: {
    async getSupplier() {
      await this.$store.dispatch("supplier/setSupplierById", this.id);
      this.supplier = this.supplierObj;
    },
    async validateForm() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.editSupplier();
    },
    async editSupplier() {
      this.supplier = {
        supplierCode: this.supplier.supplierCode,
        supplierAddress: this.supplier.supplierAddress,
        supplierDescription: this.supplier.supplierDescription,
      };
      try{
      await this.$store.dispatch("supplier/setPutSupplier", {
        id: this.id,
        supplier: this.supplier,
      });
      if (this.postResponse) {
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Supplier Updated Successfully!",
          type: "success",
        });
        this.resetForm();
        this.$router.push(`/inventory/supplier`);
      } else {
        this.warningText = this.errorMessage;
        this.warningPopup = true;
      }
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
      // if (this.errorMessage) {
      //   this.warningPopup = true;
      // }
    },

    resetForm() {
      this.supplier = supplierEmptyObj;
      this.supplier.supplierCode = "";
      this.supplier.supplierAddress = "";
      this.supplier.supplierDescription = "";
    },
    cancel() {
      this.$router.push("/inventory/supplier");
    },
  },
  watch: {},
  mounted() {
    this.id = this.$route.params.id;
    this.getSupplier();
  },
};
</script>
